
import React  from 'react';
import { BrowserRouter, Route ,Switch, Redirect } from "react-router-dom";
import './App.css'

/* ---- Pages ----*/
//import Home from "./Pages/Home";
import MeetingPage from "./Pages/MeetingPage"
import NotFound from "./Pages/404"
/* ---- Menu - Footer - Newsletter ---*/
import Menu from './components/Header/Menu';
import Footer from './components/Footer/Footer';
import Flotantes from './components/Flotantes/Flotantes';


function App () {

    const lang = '/:locale(en|es)?';
  
    return (  

            <BrowserRouter >
            <Flotantes />
                <Route path={lang} component={Menu} />
                <Switch>
                  <Route exact path={lang} component={MeetingPage} />
                  <Route exact path={`${lang}/404`} component={NotFound} /> 
                  <Redirect to={`${lang}/404`} />
                </Switch>
                <Route path={lang} component={Footer} />               
            </BrowserRouter>

            )
        };


export default App;